import { Link } from "react-router-dom";
import SEO, { pageSEO } from "../components/SEO";

export default function PrivacyPolicyPage() {
  return (
    <div data-testid="privacy-policy-page">
      <SEO {...pageSEO.privacyPolicy} />
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-[#243b5a]">
        <div className="container-max px-6 md:px-12 lg:px-24 text-center text-white">
          <h1 className="font-serif text-4xl md:text-5xl mb-4">Privacy Policy</h1>
          <p className="text-white/70">Last updated: December 2025</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding bg-white">
        <div className="container-max max-w-4xl">
          <div className="prose prose-lg max-w-none text-[#4A4A4A]">
            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Introduction</h2>
            <p>
              Awaken India Tours ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Personal Information:</strong> Name, email address, phone number, city/state, and travel preferences when you submit an inquiry form.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and referring URLs.</li>
              <li><strong>Device Information:</strong> Browser type, operating system, and device identifiers.</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Respond to your inquiries and provide travel planning services</li>
              <li>Send you relevant information about our tours and services</li>
              <li>Improve our website and customer experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Service providers who assist in operating our website and services</li>
              <li>Travel partners necessary to fulfill your booking (hotels, transportation, etc.)</li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet 
              is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Cookies</h2>
            <p>
              Our website may use cookies to enhance your browsing experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page 
              and updating the "Last updated" date.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Contact Us</h2>
            <p>
              If you have questions about this privacy policy, please contact us at:
            </p>
            <p className="mt-2">
              <strong>Email:</strong> <a href="mailto:aaron@awakenindiatours.com" className="text-[#D4AF37] hover:underline">aaron@awakenindiatours.com</a><br />
              <strong>Phone:</strong> <a href="tel:781-367-4010" className="text-[#D4AF37] hover:underline">781-367-4010</a>
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-[#243b5a] hover:text-[#D4AF37] transition-colors font-medium">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
